"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _objectAssign = _interopRequireDefault(require("object-assign"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _IconMore = _interopRequireDefault(require("../Icons/IconMore"));

var CardDropdownMenu = function CardDropdownMenu(_ref) {
  var dropdownOptions = _ref.dropdownOptions,
      _ref$dropdownProps = _ref.dropdownProps,
      dropdownProps = _ref$dropdownProps === void 0 ? {} : _ref$dropdownProps,
      htmlId = _ref.htmlId; // Overwrites any additional props passed through dropdownProps

  var mergedDropdownProps = (0, _objectAssign["default"])({
    buttonStyle: "link",
    className: "card__dropdown-button",
    displayCaret: false,
    htmlId: "".concat(htmlId, "-CardDropdownButton"),
    icon: /*#__PURE__*/_react["default"].createElement(_IconMore["default"], {
      htmlId: "card__dropdown-iconMore-".concat(htmlId)
    }),
    pullRight: true
  }, dropdownProps);
  return /*#__PURE__*/_react["default"].createElement("span", {
    id: htmlId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card__dropdown"
  }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], Object.assign({
    options: dropdownOptions.map(function (_ref2) {
      var active = _ref2.active,
          disabled = _ref2.disabled,
          divider = _ref2.divider,
          header = _ref2.header,
          label = _ref2.label,
          onSelect = _ref2.onSelect;
      return {
        active: active,
        className: "card__dropdown-item",
        disabled: disabled,
        divider: divider,
        header: header,
        label: label,
        onSelect: onSelect
      };
    })
  }, mergedDropdownProps))));
};

var _default = CardDropdownMenu;
exports["default"] = _default;